module.exports = __webpack_public_path__ + "9efd4626c60d37420d81b16096807854.MP3";